import React from "react";
import { FaSalesforce } from "react-icons/fa";
import { SiCodecademy } from "react-icons/si";
import HudFrame from "../HudFrame/HudFrame";

const photoPath = "https://portfolio-images-juhani.s3.eu-north-1.amazonaws.com/";

const education = [
  {
    logo: "https://www.uwasa.fi/themes/custom/univaasa/images/uwasa-logo.svg",
    kind: "uwasa",
    category: "Academic orbit",
    alt: "University of Vaasa",
    title: "M.Sc. in Economics",
    org: "University of Vaasa",
    year: "2007 — 2011",
    text: "Majored in business law, minored in accounting.",
  },
  {
    Icon: FaSalesforce,
    kind: "salesforce",
    category: "Certification array",
    alt: "Salesforce",
    title: "5 Salesforce Certifications",
    org: "Salesforce",
    year: "2023 — 2025",
    certifications: [
      "Platform App Builder",
      "Agentforce Specialist",
      "Platform Developer I",
      "Associate",
      "JavaScript Developer I",
    ],
  },
  {
    Icon: SiCodecademy,
    kind: "codecademy",
    category: "Training module",
    alt: "Codecademy",
    title: "Web Development Career Path",
    org: "Codecademy",
    year: "May 2020",
    text: "Completed Codecademy's Web Development Career Path.",
  },
  {
    logo: photoPath + "finva_logo.png",
    kind: "finva",
    category: "Industry clearance",
    alt: "FINVA",
    title: "Insurance Degree (VTS)",
    org: "FINVA",
    year: "2013",
    text: "Professional degree covering all major topics in the insurance industry.",
  },
];

export default function Education() {
  return (
    <div>
      <p
        className="reveal"
        style={{
          fontFamily: "var(--mono)",
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.16em",
          color: "var(--cyan)",
          marginBottom: "28px",
        }}
      >
        ▮ FLIGHT RECORD // TRAINING ARCHIVE
      </p>

      <div className="edu-flight-log">
        {education.map((el, index) => (
          <div
            key={el.title}
            className="reveal edu-row"
            data-stagger="80"
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(190px, 240px) minmax(0,1.25fr) minmax(0,0.85fr) auto",
              gap: "clamp(16px, 4vw, 40px)",
              alignItems: "center",
              padding: "clamp(30px, 5vh, 48px) 0",
              borderBottom: "1px solid var(--line)",
            }}
          >
            <HudFrame
              className={`edu-logo-frame edu-logo-frame--${el.kind}`}
              accent={el.kind === "uwasa" ? "var(--amber)" : "var(--cyan)"}
              style={{
                minHeight: "112px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                overflow: "hidden",
                background:
                  el.kind === "codecademy"
                    ? "#141c3a"
                    : "linear-gradient(135deg, rgba(12,17,28,0.96), rgba(52,224,255,0.07))",
              }}
            >
              <span className="edu-category">{el.category}</span>
              {el.Icon ? (
                <el.Icon
                  className="edu-logo edu-logo-icon"
                  role="img"
                  aria-label={el.alt}
                />
              ) : (
                <img
                  src={el.logo}
                  alt={el.alt}
                  className="edu-logo"
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: "100%",
                    height: "72px",
                    objectFit: "contain",
                    filter:
                      el.kind === "finva"
                        ? "drop-shadow(0 0 12px rgba(64,211,192,0.22))"
                        : "none",
                  }}
                />
              )}
              <span
                aria-hidden
                style={{
                  position: "absolute",
                  right: "10px",
                  bottom: "7px",
                  fontFamily: "var(--mono)",
                  fontSize: "0.58rem",
                  letterSpacing: "0.12em",
                  color: "var(--text-faint)",
                }}
              >
                LOG/{String(index + 1).padStart(2, "0")}
              </span>
            </HudFrame>

            <div className="edu-heading">
              <h4
                style={{
                  fontFamily: "var(--display)",
                  fontSize: "clamp(1.15rem, 2.5vw, 1.6rem)",
                  fontWeight: 600,
                  lineHeight: 1.1,
                  textTransform: "uppercase",
                  color: "var(--text)",
                }}
              >
                {el.title}
              </h4>
              <p
                style={{
                  fontFamily: "var(--mono)",
                  fontSize: "0.7rem",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  color: "var(--cyan)",
                  marginTop: "6px",
                }}
              >
                {el.org}
              </p>
            </div>

            {el.certifications ? (
              <ul className="edu-description edu-cert-list" aria-label="Salesforce certifications">
                {el.certifications.map((cert) => (
                  <li key={cert}>{cert}</li>
                ))}
              </ul>
            ) : (
              <p
                className="edu-description"
                style={{ color: "var(--text-soft)", fontSize: "0.94rem", lineHeight: 1.6 }}
              >
                {el.text}
              </p>
            )}

            <span
              className="edu-year"
              style={{
                fontFamily: "var(--mono)",
                fontSize: "0.78rem",
                color: "var(--text-faint)",
                whiteSpace: "nowrap",
                textAlign: "right",
              }}
            >
              {el.year}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        .edu-flight-log {
          position: relative;
          padding-left: 34px;
          border-top: 1px solid var(--line);
        }
        .edu-flight-log::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 5px;
          width: 1px;
          background: linear-gradient(
            to bottom,
            transparent,
            var(--cyan) 8%,
            rgba(52,224,255,0.2) 52%,
            var(--amber) 92%,
            transparent
          );
          box-shadow: 0 0 12px rgba(52,224,255,0.22);
        }
        .edu-row {
          position: relative;
        }
        .edu-row::before {
          content: "";
          position: absolute;
          z-index: 2;
          left: -34px;
          top: 50%;
          width: 11px;
          height: 11px;
          border: 2px solid var(--void);
          border-radius: 50%;
          background: var(--cyan);
          box-shadow: 0 0 0 1px var(--line-strong), 0 0 14px var(--glow);
          transform: translate(-50%, -50%);
          transition: transform 0.3s var(--ease), background 0.3s ease;
        }
        .edu-row:first-child::before {
          background: var(--amber);
          box-shadow: 0 0 0 1px rgba(255,179,71,0.48), 0 0 14px rgba(255,179,71,0.5);
        }
        .edu-row:hover::before {
          transform: translate(-50%, -50%) scale(1.45);
        }
        .edu-logo-frame {
          transition: border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s var(--ease);
        }
        .edu-logo-frame::before {
          content: "";
          position: absolute;
          right: -58px;
          top: -82px;
          width: 174px;
          height: 174px;
          border: 1px solid rgba(52,224,255,0.12);
          border-radius: 50%;
          pointer-events: none;
        }
        .edu-row:hover .edu-logo-frame {
          border-color: var(--line-strong) !important;
          box-shadow: 0 0 28px rgba(52,224,255,0.18);
          transform: translateY(-3px);
        }
        .edu-category {
          position: absolute;
          z-index: 2;
          top: 8px;
          left: 11px;
          font-family: var(--mono);
          font-size: 0.55rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--text-faint);
        }
        .edu-logo-frame--uwasa .edu-logo {
          height: 78px !important;
        }
        .edu-logo-frame--codecademy .edu-logo-icon {
          height: 72px !important;
          color: #ffffff;
          filter: drop-shadow(0 0 16px rgba(255,255,255,0.18));
        }
        .edu-logo-frame--finva .edu-logo {
          max-width: 165px;
        }
        .edu-logo-icon {
          width: auto !important;
          height: 76px !important;
          color: #00a1e0;
          filter: drop-shadow(0 0 18px rgba(0,161,224,0.35));
        }
        .edu-cert-list {
          list-style: none;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 7px 16px;
          color: var(--text-soft);
          font-family: var(--mono);
          font-size: 0.72rem;
          line-height: 1.45;
        }
        .edu-cert-list li {
          position: relative;
          padding-left: 13px;
        }
        .edu-cert-list li::before {
          content: "";
          position: absolute;
          top: 0.55em;
          left: 0;
          width: 5px;
          height: 5px;
          background: var(--cyan);
          box-shadow: 0 0 8px var(--glow);
        }
        @media (max-width: 720px) {
          .edu-flight-log {
            padding-left: 18px;
          }
          .edu-row {
            grid-template-columns: minmax(0, 1fr) !important;
            gap: 20px !important;
            padding: 34px 0 38px !important;
          }
          .edu-row::before {
            left: -18px;
            top: 93px;
            width: 9px;
            height: 9px;
          }
          .edu-logo-frame {
            width: 100% !important;
            min-height: 118px !important;
            justify-content: flex-start !important;
            padding: 22px 24px !important;
          }
          .edu-logo-frame--uwasa .edu-logo {
            max-width: 270px;
          }
          .edu-logo-frame--codecademy .edu-logo-icon {
            height: 76px !important;
          }
          .edu-logo-frame--finva .edu-logo {
            max-width: 190px;
          }
          .edu-heading,
          .edu-description,
          .edu-year {
            grid-column: 1 !important;
            text-align: left !important;
          }
          .edu-description {
            max-width: 34ch;
          }
          .edu-cert-list {
            grid-template-columns: minmax(0, 1fr);
            gap: 9px;
            font-size: 0.75rem;
          }
          .edu-year {
            color: var(--cyan) !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .edu-logo-frame,
          .edu-row::before { transform: none !important; }
        }
      `}</style>
    </div>
  );
}
